module.exports = __webpack_public_path__ + "static/media/add teachers evaluation.3601cc4a.svg";